module.exports = __webpack_public_path__ + "static/media/engineerstudents_museumofart-12.9c6f4b1c.jpg";